<template>
  <div class="error_topic_detail">
    <div class="header">
      <span class="goback" @click="GoBack">
        <i class="iconfont">&#xe629;</i>
      </span>
    </div>
    <div class="content">
      <div class="topic">
        <div class="title">
          <span
            v-if="TopicData && TopicData.length"
          >{{currIndex+1}}、{{TopicData.length && TopicData[currIndex].examTypeDesc}}</span>
          <span v-else>暂无更多题</span>
        </div>
        <div class="topic_content" v-if="TopicData && TopicData.length">
          <div class="content_html" v-html="TopicData[currIndex].content"></div>
          <div class="topic_option" v-if="TopicData[currIndex].examType == 1">
            <el-radio-group v-model="radioValue" @change="clickOption">
              <div v-for="(item,index) in TopicData[currIndex].info" :key="index">
                <div class="option_item">
                  <el-radio border :label="item.id" :value="item.id">
                    <span class="space">{{index | computedNum}}</span>
                    <div class="item_content" v-html="item.content"></div>
                  </el-radio>
                </div>
              </div>
            </el-radio-group>
          </div>
          <div class="topic_option" v-if="TopicData[currIndex].examType == 2">
            <el-checkbox-group v-model="checkList" @change="clickOption">
              <div v-for="(item,index) in TopicData[currIndex].info" :key="index">
                <div class="option_item">
                  <el-checkbox border :label="item.id" :value="item.id">
                    <span class="space">{{index | computedNum}}</span>
                    <div class="item_content" v-html="item.content"></div>
                  </el-checkbox>
                </div>
              </div>
            </el-checkbox-group>
          </div>
          <div class="topic_option" v-if="TopicData[currIndex].examType == 4">
            <el-radio-group v-model="judgeOption" @change="clickOption">
              <div v-for="(item,index) in judgeData" :key="index">
                <div class="option_item">
                  <el-radio border :label="item.isAnswer" :value="item.isAnswer">
                    <div class="judge_item">{{item.isAnswer == 1 ? '正确' : '错误'}}</div>
                  </el-radio>
                </div>
              </div>
            </el-radio-group>
          </div>
        </div>
        <div class="next" v-if="TopicData && TopicData.length > 1">
          <el-button
            class="next_btn"
            :class="isDisabled ? 'isdisabled' : ''"
            :disabled="isDisabled"
            @click="nextTopic"
          >{{currIndex+1 == TopicData.length ? '提交': '下一题'}}</el-button>
        </div>
      </div>
      <div class="timer">
        <div class="time_number">
          <div class="timing">
            <span class="title">计时器</span>
            <span ref="startTimer" class="number">00:00:00</span>
          </div>
        </div>
        <div class="errdata_record">
          <div class="record_part1">
            <div class="title">待订正题数</div>
            <div class="total_num">230</div>
            <div class="wancheng_num">- 已做4题 -</div>
          </div>
          <div class="record_part2">
            <div class="nav1">
              <span class="isright">正确</span>
              <span class="num">2</span>
            </div>
            <div class="nav2">
              <span class="isright">错误</span>
              <span class="num">2</span>
            </div>
          </div>
          <div class="record_part3">
            <div class="btn">结束订正</div>
            <div class="tips">结束后，将自动保存之前订正的题目</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import api from "../axios/interface";
export default {
  name: "ErrorTopic",
  data() {
    return {
      TopicData: [],
      currIndex: 0,
      radioValue: "", // 当前单选题选项
      checkList: [], // 当前选择数组
      judgeOption: "",
      timer: "",
      content: "",
      hour: 0,
      minutes: 0,
      seconds: 0,
      currtimer: 0, // 当前计时
      judgeData: [{ isAnswer: 0 }, { isAnswer: 1 }],
      subjectId: this.$route.query.subjectId,
      isDisabled: true // 是否可以点击下一题
    };
  },
  components: {
    Header: Header,
    Footer: Footer
  },
  filters: {
    computedNum(val) {
      let option = "";
      switch (Number(val)) {
        case 0:
          option = "A";
          break;
        case 1:
          option = "B";
          break;
        case 2:
          option = "C";
          break;
        case 3:
          option = "D";
          break;
        case 4:
          option = "E";
          break;
        case 5:
          option = "F";
          break;
        case 6:
          option = "G";
          break;
        case 7:
          option = "H";
          break;
        default:
          option = "";
          break;
      }
      return option;
    }
  },
  watch: {
    currIndex(val,newVal) {
      if((val+1) == this.TopicData.length){
         console.log('val', '最后一题了')
      }
      // if((newVal+1) == this.TopicData.length){
      //   console.log('tag', '最后一题了')
      // }
      console.log('val', val)
      console.log('newval', newVal)

     if(this.TopicData[val].examType == 3){
       let a = $('.tiankong')
       console.log('进来了', a)
        $('.tiankong').on('input',function(e){
          console.log('nextTick', e)
          that.clickOption()
        })
     }
    }
  },
  created() {
    clearInterval(this.timer);
    this.timer = setInterval(this.startTimer, 1000);
  },
  mounted() {
    this.getWrongTopic();
  },
  updated() {
    let that = this

    // 如果是选择题则在页面渲染完成后给input添加事件
    if(this.TopicData[this.currIndex].examType == 3){
      this.$nextTick().then(() => {
        $('.tiankong').on('input',function(e){
          this.clickOption()
        })
      })
    }
  },
  methods: {
    // 获取错题本数据统计接口
    getWrongTopic() {
      let that = this;
      this.$axios
        .get(
          api.ExamQuestionList,
          { subjectId: this.subjectId },
          { hideMessage: true }
        )
        .then(res => {
          res.result.data.map(item => {
            if (item.examType == 3) {
              item.content = item.content.replace(
                '<span style="text-decoration: underline;">&nbsp; &nbsp; &nbsp; &nbsp;</span>',
                '<input type="text" class="tiankong"/>'
              );
            }
          });
          this.TopicData = res.result.data;
          this.$nextTick().then(() => {
            $('.tiankong').on('input',function(e){
              console.log('nextTick', e)
              that.clickOption()
            })
          })
        })
        .catch(res => {});
    },

    // 选择题选项
    clickOption(val) {
      if (this.TopicData[this.currIndex].examType == 1) {
        // 单选题
        this.isDisabled = false;
        console.log( "单选题提交答案", this.TopicData[this.currIndex].id + "--" + val );
      }else if (this.TopicData[this.currIndex].examType == 2){
        console.log('多选题', this.checkList)
        if(this.checkList.length > 1){
          this.isDisabled = false
        }

      }else if (this.TopicData[this.currIndex].examType == 4) {
        // 判断题
        console.log(
          "判断题提交答案",
          this.TopicData[this.currIndex].id + "--" + val
        );
        this.isDisabled = false;
      }else if(this.TopicData[this.currIndex].examType == 3) { // 填空题
        let arr = $('.tiankong')
        let brr = []
        for (var i = 0, j = arr.length; i < j; i++){
          brr.push(arr[i].value)
          console.log('tag', arr[i].value)
        }
        console.log('tag', brr)
        this.isDisabled = false;
      }
    },

    // 下一题
    nextTopic() {
      // 如果当前题不是最后一题
      if((this.currIndex+1) == this.TopicData.length){
        console.log("最后一题提交")
        // 跳转页面
      }else if (this.currIndex < this.TopicData.length) {
        this.currIndex = this.currIndex + 1;
        this.isDisabled = true;
      }
      let arr = $('.tiankong')
        let brr = []
        for (var i = 0, j = arr.length; i < j; i++){
          brr.push(arr[i].value)
          console.log('tag', arr[i].value)
        }
        console.log('tag', brr)
        this.isDisabled = false;
    },

    GoBack() {
      this.$router.go(-1);
    },

    startTimer() {
      this.currtimer += 1;
      this.seconds += 1;
      if (this.seconds >= 60) {
        this.seconds = 0;
        this.minutes = this.minutes + 1;
      }

      if (this.minutes >= 60) {
        this.minutes = 0;
        this.hour = this.hour + 1;
      }
      this.$refs.startTimer.innerHTML =
        (this.hour < 10 ? "0" + this.hour : this.hour) +
        ":" +
        (this.minutes < 10 ? "0" + this.minutes : this.minutes) +
        ":" +
        (this.seconds < 10 ? "0" + this.seconds : this.seconds);
    }
  },

  destroyed() {
    clearInterval(this.timer);
  }
};
</script>
<style>
.content_html .tiankong {
  padding: 0 10px;
  width: 60px;
  height: 22px;
  border: none;
  text-align: center;
  background-color: transparent;
  border-bottom: 1px solid #333333;
}
.content_html p input:focus {
  outline: none;
  border-bottom: 1px solid #333333 !important;
}
</style>
<style lang='less' scoped>
.error_topic_detail {
  width: 100%;
  min-height: 800px;
  background-color: #0079fe;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 95px;
  .header {
    width: 1200px;
    height: 48px;
    line-height: 45px;
    margin: 0 auto;
    .goback {
      color: #fff;
      margin-left: 30px;
      i {
        font-size: 23px;
        cursor: pointer;
      }
    }
  }
  .content {
    min-height: 780px;
    margin-top: 56px;
    width: 960px;
    display: flex;
    .topic {
      width: 624px;
      min-height: 600px;
      background-color: #fff;
      position: relative;
      border-radius: 4px;
      .title {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 56px;
        padding-left: 24px;
        background-color: #eeeeee;
        span {
          font-size: 16px;
          color: #333;
          font-weight: 500;
        }
      }
      .topic_content {
        padding: 24px 50px 24px 24px;
        color: #333333;
        line-height: 22px;

        .topic_option {
          .option_item {
            position: relative;
            // 单选、判断
            /deep/.el-radio.is-bordered {
              height: auto;
            }
            /deep/.el-radio {
              display: flex;
              height: auto;
              width: 550px;
              max-width: 550px;
              margin-top: 12px;
              padding: 0px 0px 0 0;
              &:first-of-type {
                margin-top: 32px;
              }
              .el-radio__input {
                display: none;
              }
              .el-radio__label {
                display: flex;
                line-height: 40px;
                padding: 0;
                .item_content {
                  padding: 0 20px;
                  max-width: 460px;
                  overflow: hidden;
                  white-space: pre-wrap;
                }
                .space {
                  display: inline-block;
                  text-align: center;
                  width: 40px;
                  height: auto;
                  border-right: 1px solid #dcdfe6;
                }
                .judge_item {
                  padding-left: 20px;
                  width: 530px;
                }
              }
            }
            // 多选
            /deep/.el-checkbox {
              display: flex;
              height: auto;
              width: 550px;
              max-width: 550px;
              margin-top: 12px;
              padding: 0px 0px 0 0;
              &:first-of-type {
                margin-top: 32px;
              }
              .el-checkbox__input {
                display: none;
              }
              .el-checkbox__label {
                display: flex;
                line-height: 40px;
                padding: 0;
                .item_content {
                  padding: 0 20px;
                  max-width: 460px;
                  overflow: hidden;
                  white-space: pre-wrap;
                }
                .space {
                  display: inline-block;
                  text-align: center;
                  width: 40px;
                  height: auto;
                  border-right: 1px solid #dcdfe6;
                }
                .judge_item {
                  padding-left: 20px;
                  width: 530px;
                }
              }
            }
          }
        }
      }
      .next {
        position: absolute;
        bottom: 0;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        background-color: #eeeeee;
        height: 56px;
        width: 100%;
        .next_btn {
          cursor: pointer;
          padding: 0 15px;
          font-size: 14px;
          line-height: 28px;
          margin-right: 48px;
          margin: 12px 48px 12px 0;
          height: 28px;
          background-color: #0079fe;
          color: #fff;
          border-radius: 4px;
        }
        .isdisabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }
    }
    .timer {
      margin-left: 48px;
      background-color: #fff;
      border-radius: 4px;
      width: 288px;
      .time_number {
        height: 160px;
        color: #fff;
        background: url("../assets/images/back-time.png") no-repeat;
        background-size: 288px 160px;

        .timing {
          padding: 39px 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .title {
            font-size: 16px;
            line-height: 22px;
            text-align: center;
          }
          .number {
            font-size: 40px;
            line-height: 56px;
            text-align: center;
          }
        }
      }
      .errdata_record {
        color: #333333;
        .record_part1 {
          display: flex;
          flex-direction: column;
          align-items: center;
          .title {
            font-size: 16px;
            line-height: 22px;
            margin-top: 26px;
          }
          .total_num {
            font-size: 40px;
            line-height: 56px;
          }
          .wancheng_num {
            font-size: 14px;
            line-height: 22px;
          }
        }
        .record_part2 {
          display: flex;
          justify-content: space-around;
          .nav1,
          .nav2 {
            display: flex;
            flex-direction: column;
            text-align: center;
            .isright {
              margin: 12px 0;
              font-size: 14px;
              line-height: 22px;
            }
            .num {
              font-size: 32px;
              line-height: 36px;
            }
          }
        }
        .record_part3 {
          display: flex;
          flex-direction: column;
          align-items: center;
          .btn {
            background-color: #0079fe;
            width: 88px;
            height: 32px;
            cursor: pointer;
            color: #ffffff;
            text-align: center;
            font-size: 14px;
            border-radius: 4px;
            line-height: 32px;
            margin-top: 60px;
          }
          .tips {
            margin-top: 16px;
            font-size: 12px;
            color: #999999;
          }
        }
      }
    }
  }
}
</style>
